// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__Xlpm_","inputWrap":"Table_inputWrap__3nk2m","col":"Table_col__1QbCQ","bmiTooltip":"Table_bmiTooltip__16SDm"};